const DECIMAL = /^[+-]?\d+(\.\d+)?$/;

export function toNumber(value: unknown): number | null {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }
  if (typeof value === 'string') {
    const text = value.trim();
    const n = Number(text);
    return DECIMAL.test(text) && Number.isFinite(n) ? n : null;
  }
  return null;
}